import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { contentApi } from "./content";
import {
  fontStacks,
  visualIdentityQueryKey,
} from "./visual-identity";

export function VisualIdentityController() {
  const { data } = useQuery({
    queryKey: visualIdentityQueryKey,
    queryFn: () => contentApi.getTypographySettings(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  useEffect(() => {
    if (!data) return;
    const root = document.documentElement;
    root.style.setProperty("--font-display", fontStacks[data.heading]);
    root.style.setProperty("--font-subtitle", fontStacks[data.subtitle]);
    root.style.setProperty("--font-serif", fontStacks[data.subtitle]);
    root.style.setProperty("--font-editorial", fontStacks[data.subtitle]);
    root.style.setProperty("--font-ui", fontStacks[data.body]);
    root.style.setProperty("--font-sans", fontStacks[data.body]);
  }, [data]);

  return null;
}
